/* eslint-disable */

import ModelComponentAccountPlan from "../model-component-account-plan/model-component-account-plan.tsx";
import ModelComponentAccountPlanExecution from "../model-component-account-plan-execution/model-component-account-plan-execution.tsx";
import ModelComponentPaymentMethod from "../model-component-payment-method/model-component-payment-method";
import ModelComponentUserPII from "../model-component-user-pii/model-component-user-pii.tsx";
import ModelComponentUserStatus from "../model-component-user-status/model-component-user-status.tsx";

import ModelComponentOrganisationTransfer from "../model-component-organisation-transfer/model-component-organisation-transfer";
import ModelComponentNote from "../model-component-note/model-component-note.tsx";
import ModelComponentOrganisationActivity from "../model-component-organisation-activity/model-component-organisation-activity";
import ModelComponentIncidentStatus from "../model-component-incident-status/model-component-incident-status";

const ReadableDateTime = ({ datetime }) => {
  const date = new Date(datetime);
  const formattedDate = new Intl.DateTimeFormat("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric",
  }).format(date);

  return <span>{formattedDate}</span>;
};

const NimbusTimelineItem = ({ type, data, date, datePrevious }) => {
  let icon = "fa-user";
  let title = "Unknown event";
  let timelineElement = (
    <div
      className={`flex flex-col w-full  rounded-lg p-2 text-left
    bg-color-background-secondary dark:bg-color-dark-background-secondary
    `}
    >
      <div>{date}</div>
      <div>{type}</div>
      <pre className="text-sm">{JSON.stringify(data, null, 2)}</pre>
    </div>
  );

  if (type === "ACCOUNT_PLAN") {
    title = "Account Plan updated";
    icon = "fa-circle-notch";
    timelineElement = (
      <ModelComponentAccountPlan
        id={data.id}
        sausages={data.sausages}
        subunits={data.subunits}
        subunitsCurrency={data.subunits_currency}
        contributionDay={data.contribution_day}
      />
    );
  } else if (type === "USER_PII") {
    icon = "fa-user";
    title = "Personally Identifiable Information (PII) updated";
    timelineElement = (
      <ModelComponentUserPII
        userPIIId={data.id}
        userId={data.user_id}
        nameLegal={data.name_legal}
        namePreferred={data.name_preferred}
        email={data.email}
        isEditable={false}
      />
    );
  } else if (type === "USER_STATUS") {
    icon = "fa-battery";
    title = "AccountUser Status updated";
    timelineElement = (
      <ModelComponentUserStatus
        userStatusId={data.id}
        statusTitle={data.status}
      />
    );
  } else if (type === "ACCOUNT_PLAN_EXECUTION") {
    icon = "fa-regular fa-circle-up";
    title = "Account Plan Execution";
    timelineElement = (
      <ModelComponentAccountPlanExecution
        accountPlanExecutionId={data.id}
        subunits={data.subunits}
        subunitsCurrency={data.subunits_currency}
        subunitsFee={data.subunits_fee}
        subunitsRaindrop={data.subunits_raindrop}
        accountPlanExecutionSausages={data.execution_sausages}
        paymentProviderIdentifierStripe={
          data.payment_provider_identifier_stripe
        }
        availableAt={data.available_at}
      />
    );
  } else if (type === "PAYMENT_METHOD") {
    icon = "fa-credit-card";
    title = "Payment Method updated";
    timelineElement = (
      <ModelComponentPaymentMethod
        paymentMethodId={data.id}
        createdAt={data.created_at}
        paymentMethodIdentifierStripe={
          data.payment_provider === "STRIPE"
            ? data.payment_provider_identifier
            : null
        }
        paymentMethodIdentifierGoCardless={
          data.payment_provider === "GO_CARDLESS"
            ? data.payment_provider_identifier
            : null
        }
      />
    );
  } else if (type == "ORGANISATION_ACTIVITY") {
    icon = "fa-clipboard-list";
    title = "Organisation Activity created";
    timelineElement = (
      <ModelComponentOrganisationActivity id={data.id} heading={data.heading} />
    );
  } else if (type === "ORGANISATION_TRANSFER") {
    icon = "fa-exchange";
    title = "Organisation Transfer";
    timelineElement = (
      <ModelComponentOrganisationTransfer
        id={data.id}
        subunits={data.subunits}
        subunitsCurrency={data.subunits_currency}
        transferred_at={data.transferred_at}
        stripe_transfer_id={data.stripe_transfer_id}
        stripePayoutId={data.stripe_payout_id}
        status={data.status}
        rawData={data}
      />
    );
  } else if (type === "NOTE") {
    icon = "fa-notes-medical";
    title = "Note created";
    timelineElement = (
      <ModelComponentNote
        id={data.id}
        text={data.text}
        createdAt={data.created_at}
        createdBy={data.created_by}
      />
    );
  } else if (type === "INCIDENT_STATUS") {
    icon = "fa-battery";
    title = "Incident Status updated";
    timelineElement = (
      <ModelComponentIncidentStatus id={data.id} status={data.status} />
    );
  }

  return (
    <div className="flex flex-col gap-2 mt-10 w-full">
      <div className="flex flex-row items-center gap-4">
        <i
          className={`flex flex-row w-10 text-justify justify-center items-center fas ${icon} 
        text-color-text-tertiary dark:text-color-dark-text-tertiary
        `}
        ></i>

        <div className="flex flex-col w-full">
          <h4 className="whitespace-nowrap">{title}</h4>
          <div
            className={`flex flex-row gap-4 text-xs
          text-color-text-secondary dark:text-color-dark-text-secondary
          `}
          >
            <ReadableDateTime datetime={date} />
          </div>
        </div>
      </div>

      <div
        className={`pl-5 border-l ml-5 
      dark:border-color-dark-border-primary border-color-border-primary`}
      >
        {timelineElement}
      </div>
    </div>
  );
};

export default NimbusTimelineItem;
